import { TipoPesquisaContract } from 'app/types/simulacao-preco/TipoPesquisaContract'
import {BaseApi} from './BaseApi'

export class TipoPesquisaApi extends BaseApi {
    async listar() : Promise<TipoPesquisaContract[]> {
        const {data: tiposPesquisa} = await this.api.get(`/TipoPesquisa/Listar`)

        return tiposPesquisa

    }
}